"use client";
import React, { useState, useEffect } from "react";
import CurrencyCard from "./CurrencyCard";
import useTranslation from "@/hook/useTranslation";

const PriceMarketLayout = () => {
  const [forexData, setForexData] = useState();
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  async function fetchScrapedData() {
    try {
      const res = await fetch("/api/scrape");

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const data = await res.json(); // Attempt to parse JSON
      const output = [];
      if (data && Array.isArray(data)) {
        for (var i = 0; i < 5; i++) {
          output.push(data[i]);
        }
        setForexData(output);
      } else {
        console.warn("Expected array but got:", data);
        setError("Invalid data format received from scraper.");
      }
    } catch (error) {
      console.error("Error fetching scraped data:", error.message);
    }
  }

  useEffect(() => {
    fetchScrapedData();
  }, []);

  if (error) {
    return <div>{error}</div>;
  }

  if (forexData) {
    return (
      <div className="price-market-layout">
        <img className="bull" src={"/images/bull.png"}></img>
        <img className="bear" src={"/images/bear.png"}></img>
        <div className="content">
          <div className="price-title">{t("topPairTitle")}</div>
          {forexData.map((data, index) => {
            // Data is already sliced, so it will only iterate over the first 9 items
            const symbol = data.pair;
            const rate = data.rate;
            const changePips = data.changePips;
            const changePercent = data.changePercent;

            return (
              <CurrencyCard
                key={index} // You can also use symbol here for unique key
                currencyPair={symbol}
                rate={rate}
                changePips={changePips}
                changePercent={changePercent}
              />
            );
          })}
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default PriceMarketLayout;
